module.exports = [
	{
		"componentChunkName": "component---node-modules-gatsby-plugin-offline-app-shell-js",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "offline-plugin-app-shell-fallback.json",
		"path": "/offline-plugin-app-shell-fallback/"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "local-or-global-choosing-a-secondary-index-type-in-dynamo-db.json",
		"path": "/local-or-global-choosing-a-secondary-index-type-in-dynamo-db"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "dynamodb-streams.json",
		"path": "/dynamodb-streams"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "global-secondary-indexes.json",
		"path": "/global-secondary-indexes"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "local-secondary-indexes.json",
		"path": "/local-secondary-indexes"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "secondary-indexes.json",
		"path": "/secondary-indexes"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "mongo-db-vs-dynamo-db.json",
		"path": "/mongo-db-vs-dynamo-db"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "working-with-multiple-items.json",
		"path": "/working-with-multiple-items"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "filtering.json",
		"path": "/filtering"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "scans.json",
		"path": "/scans"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "querying.json",
		"path": "/querying"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "hierarchical-data.json",
		"path": "/hierarchical-data"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "leaderboard-write-sharding.json",
		"path": "/leaderboard-write-sharding"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "data-modeling-overview.json",
		"path": "/data-modeling-overview"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "backups-restores.json",
		"path": "/backups-restores"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "autoscaling.json",
		"path": "/autoscaling"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "provisioning-tables.json",
		"path": "/provisioning-tables"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "global-tables.json",
		"path": "/global-tables"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "security.json",
		"path": "/security"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "additional-reading.json",
		"path": "/additional-reading"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "anatomy-of-an-item.json",
		"path": "/anatomy-of-an-item"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "inserting-retrieving-items.json",
		"path": "/inserting-retrieving-items"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "updating-deleting-items.json",
		"path": "/updating-deleting-items"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "environment-setup.json",
		"path": "/environment-setup"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "expression-basics.json",
		"path": "/expression-basics"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "the-dynamo-paper.json",
		"path": "/the-dynamo-paper"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "key-concepts.json",
		"path": "/key-concepts"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "what-is-dynamo-db.json",
		"path": "/what-is-dynamo-db"
	},
	{
		"componentChunkName": "component---src-pages-about-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "about.json",
		"path": "/about/"
	},
	{
		"componentChunkName": "component---src-pages-index-jsx",
		"layout": "index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "index.json",
		"path": "/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 15178676390636814000